import React, {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {useTitle} from "../../../contexts/title";
import UserEditForm from '../../../features/cfi/user/components/UserEditForm';

export default function EditUserPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Edit User')
	}, [pageTitle]);

	const params = useParams();

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<UserEditForm userName={params.userName} />
			</div>
		</React.Fragment>
	)
} 
